import { CmsService } from '@omnia/ui/src/lib'
import { navigationService } from '@/common/services/navigation.service'
import type { InitialData } from './models/initialData'
import type { PagesEnum } from './models/pages'

export class CurzonCmsService extends CmsService<InitialData, PagesEnum> {
    // Add custom methods here
}

// @ts-expect-error -- unfinished type implementation of `SubPageKey`
export const cmsService = new CurzonCmsService(navigationService)
